// Arbeitszeit des Betriebs: EINE Stelle zum Lesen (Kalender, „Nächste freie Zeit“). Gespeichert in den Termin-Einstellungen
// (GET/PUT /module-termine/admin/settings); ohne Eintrag gelten die Standards (Mo–Fr, 07:00–17:00).
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const STANDARD_ARBEITSZEIT = { tage: [1, 2, 3, 4, 5], von: "07:00", bis: "17:00" };
const TAGNAMEN = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
export const WOCHENTAGE = [[1, "Mo"], [2, "Di"], [3, "Mi"], [4, "Do"], [5, "Fr"], [6, "Sa"], [0, "So"]];
export const tagName = (n) => TAGNAMEN[n];

const inMin = (w, falls) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(w || ""));
  return m ? Number(m[1]) * 60 + Number(m[2]) : falls;
};

/** Einstellungen -> { tage, von, bis, vonMin, bisMin } (ungültige/fehlende Werte = Standard) */
export const arbeitszeitAus = (s) => {
  const tage = Array.isArray(s?.arbeitstage) && s.arbeitstage.length ? s.arbeitstage.filter((t) => Number.isInteger(t) && t >= 0 && t <= 6) : STANDARD_ARBEITSZEIT.tage;
  let vonMin = inMin(s?.arbeit_von, 7 * 60), bisMin = inMin(s?.arbeit_bis, 17 * 60);
  if (bisMin <= vonMin) { vonMin = 7 * 60; bisMin = 17 * 60; }
  const z = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
  return { tage: tage.length ? tage : STANDARD_ARBEITSZEIT.tage, von: z(vonMin), bis: z(bisMin), vonMin, bisMin };
};

let zwischen = null;
export const arbeitszeitVergessen = () => { zwischen = null; };
export const ladeArbeitszeit = () => {
  if (!zwischen) zwischen = api.get("/module-termine/admin/settings").then((r) => arbeitszeitAus(r.data)).catch(() => { zwischen = null; return arbeitszeitAus(null); });
  return zwischen;
};

export const useArbeitszeit = () => {
  const [az, setAz] = useState(() => arbeitszeitAus(null));
  useEffect(() => { let lebt = true; ladeArbeitszeit().then((a) => { if (lebt) setAz(a); }); return () => { lebt = false; }; }, []);
  return az;
};
